export default import.meta.ROLLDOWN_FILE_URL_KNSCq18IxAbYGwmHFzrGnA